import React from "react";

const Footer = () => {
  return (
    <footer className="w-full bg-black/10 min-h-[80px] shadow-[0_0_4px_rgba(255,255,255,0.15)] flex items-center justify-center">
      <a href="https://github.com/Farrely-F" target="__blank" className="font-light text-xs md:text-sm">
        TokpedPlayClone © Farrely Firenza Generasi GIGIH3.0
      </a>
    </footer>
  );
};

export default Footer;
